import ls from '@utils/localStorage';

const USER_TIMELINE_STORAGE_KEY = 'user-timeline-current';

export interface UserTimelineState {
  globalFilter: any;
  selectedMetrics: string[];
  timestamp: number;
}

/**
 * Save user timeline state to localStorage
 * Stores the global filter and selected metrics with current timestamp
 */
export const saveUserTimelineState = (state: Omit<UserTimelineState, 'timestamp'>) => {
  try {
    const stateWithTimestamp: UserTimelineState = {
      ...state,
      timestamp: Date.now(),
    };

    ls.set({
      key: USER_TIMELINE_STORAGE_KEY,
      value: stateWithTimestamp,
      expires: 1000 * 60 * 60 * 24, // 24 hours
    });
  } catch (error) {
    console.error('Failed to save user timeline state to localStorage:', error);
  }
};

/**
 * Load user timeline state from localStorage
 * Returns null if no state exists or if it has expired
 */
export const loadUserTimelineState = (): UserTimelineState | null => {
  try {
    const state = ls.get(USER_TIMELINE_STORAGE_KEY);

    if (!state || typeof state !== 'object') {
      return null;
    }

    // Validate the structure - globalFilter must exist, selectedMetrics must be an array (can be empty)
    if (!state.globalFilter) {
      return null;
    }

    if (!Array.isArray(state.selectedMetrics)) {
      return null;
    }

    return state as UserTimelineState;
  } catch (error) {
    console.error('Failed to load user timeline state from localStorage:', error);
    return null;
  }
};

/**
 * Clear user timeline state from localStorage
 */
export const clearUserTimelineState = () => {
  try {
    ls.remove(USER_TIMELINE_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear user timeline state from localStorage:', error);
  }
};
